import React, { Component } from 'react';
import $ from 'jquery';
import flatten from 'lodash/flatten'
import get from 'lodash/get'
import find from 'lodash/find'

export default class Calculator extends Component {
    constructor(props) {
        super(props);
        this.defaultOption = {
            selectedOption: '',
            selectedOptionPrice: 0,
            quantity: 0,
        }
        this.state = {
            totalPrice: 35,
            options: [this.defaultOption],
            disposal: 0
        };

        this.changePrice = this.changePrice.bind(this);
        this.addRow = this.addRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
    }
    data = [];

    fetchData() {
        $.get('/data/assembly_config.json').done(data => {
            this.data = data.departments;
        });
    }

    get selectOptions() {
        const names = this.data.map(department => {
            const names = department.products.map(product => {
                return `${department.name} -- ${product.name}`;
            })
            return names;
        })
        return flatten(names);
    }

    // render the select option
    renderOption = (option, i) => {
        return <option value={option} key={i}>{option}</option>;
    }

    // gets the price of the selected option
    getOptionPrice(option) {
        const split = option.split(' -- ')
        const [ department, product ] = split
        const data = find(this.data, d => d.name === department)
        const products = get(data, 'products', [])
        return get(find(products, p => p.name === product), 'price', 0)
    }

    // event handler for select and input field
    changePrice(index, event) {
        const { target } = event;
        const stateOptionsClone = JSON.parse(JSON.stringify(this.state.options));

        if (target.name === 'pckRmvChkBox') {
            this.setState((state) => ({
                totalPrice: state.totalPrice += (15 * (target.checked ? 1 : -1)),
                disposal: target.checked ? 15 : 0
            }))
            return
        }

        if (target.name === 'assemSelect') {
            stateOptionsClone[index].selectedOption = target.value;
            stateOptionsClone[index].selectedOptionPrice = this.getOptionPrice(target.value);
        } else {
            const value = Number(target.value);
            stateOptionsClone[index].quantity = value
        }
        this.setState({ options: stateOptionsClone });
    }

    lineItemPrice({ selectedOptionPrice, quantity }) {
        return selectedOptionPrice * quantity
    }

    get totalPrice() {
        let { totalPrice, options } = this.state;
        return options.reduce((acc, o) => {
            acc += this.lineItemPrice(o)
            return acc
        }, totalPrice)
    }

    addRow(ev) {
        ev.preventDefault()
        const stateClone = JSON.parse(JSON.stringify(this.state));
        stateClone.options.push(this.defaultOption);
        this.setState({ options: stateClone.options });
    }

    deleteRow(index, ev) {
        ev.preventDefault()
        const stateClone = JSON.parse(JSON.stringify(this.state));
        stateClone.options.splice(index, 1);
        this.setState({ options: stateClone.options });
    }

    customRow = (options) => {
        const listItems = options.map((row, index) =>
            <div key={index} className="Rtable Rtable--5cols Rtable--collapse">
                <div className="Rtable-cell Rtable-cell--add"><button className="btn btn-default" onClick={this.addRow}>Add</button></div>
                <div className="Rtable-cell Rtable-cell--product" data-field="Product">
                    <select className="form-control" id="assemSelect" name="assemSelect" onChange={(e) => this.changePrice(index, e)}>
                        <option name="assemSelect" value="">-----------------------</option>
                        {this.selectOptions.map(this.renderOption)}
                    </select>
                </div>
                <div className="Rtable-cell Rtable-cell--qty" data-field="Qty">
                    <input type="text" className="form-control" onKeyUp={(e) => this.changePrice(index, e)} maxLength="3" name="qty" />
                </div>
                <div className="Rtable-cell Rtable-cell--price" data-field="Price">{ `$${this.lineItemPrice(row)}` }</div>
                {
                    index === 0 ? <div className="Rtable-cell Rtable-cell--delete xs-hide" /> :
                                  <div className="Rtable-cell Rtable-cell--delete"><button onClick={(e) => this.deleteRow(index, e)}>Delete</button></div>
                }
            </div>
        )
        return listItems;
    }

    componentDidMount() {
        document.title = `Assembly Calculator - C&A Assembly & Installation Solution`;

        this.fetchData()
    }

    render() {
        let { options } = this.state;
        return (
            <div className="calculator">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <h1>Furniture Assembly Costs Calculator</h1>

                            <div className="Rtable Rtable--5cols Rtable--collapse Rtable--headings">
                                <div className="Rtable-cell Rtable-cell--add"></div>
                                <div className="Rtable-cell Rtable-cell--product"><h3>Product</h3></div>
                                <div className="Rtable-cell Rtable-cell--qty"><h3>Qty</h3></div>
                                <div className="Rtable-cell Rtable-cell--price"><h3>Price</h3></div>
                                <div className="Rtable-cell Rtable-cell--delete"></div>
                            </div>
                            {this.customRow(options)}
                            <div className="Rtable Rtable--5cols Rtable--collapse">
                                <div className="Rtable-cell Rtable-cell--add xs-hide"></div>
                                <div className="Rtable-cell Rtable-cell--product xs-hide">Call out fee</div>
                                <div className="Rtable-cell Rtable-cell--qty xs-hide"></div>
                                <div className="Rtable-cell Rtable-cell--price" data-field="Call out fee">$35</div>
                                <div className="Rtable-cell Rtable-cell--delete xs-hide"></div>
                            </div>
                            <div className="Rtable Rtable--5cols Rtable--collapse">
                                <div className="Rtable-cell Rtable-cell--add xs-hide"></div>
                                <div className="Rtable-cell Rtable-cell--product xs-hide">Packaging &amp; disposal (optional)</div>
                                <div className="Rtable-cell Rtable-cell--qty" data-field="Packaging &amp; disposal (optional)">
                                    <div className="checkbox">
                                        <label>
                                            <input type="checkbox" name="pckRmvChkBox" id="pckRmvChkBox" onChange={(e) => this.changePrice(null, e)} />yes/no
                                        </label>
                                    </div>
                                </div>
                                <div className="Rtable-cell Rtable-cell--price xs-hide">{ `$${this.state.disposal}` }</div>
                                <div className="Rtable-cell Rtable-cell--delete xs-hide"></div>
                            </div>
                            <div className="Rtable Rtable--5cols Rtable--collapse total-price">
                                <div className="Rtable-cell Rtable-cell--add xs-hide"></div>
                                <div className="Rtable-cell Rtable-cell--product xs-hide">Total Price: </div>
                                <div className="Rtable-cell Rtable-cell--qty xs-hide"></div>
                                <div className="Rtable-cell Rtable-cell--price" data-field="Total Price">{`$${this.totalPrice}`}</div>
                                <div className="Rtable-cell Rtable-cell--delete xs-hide"></div>
                            </div>
                            <h6 className="text-center">Please note prices are indicative only. Please call us for a more accurate quotation.</h6>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/Calculator.js